import { API_BASE_URL } from '@/lib/api';

/** Absolute cover URL for feed and detail, or null when the entry has no cover. */
export function coverSrc(item: { coverUrl: string | null }): string | null {
  return item.coverUrl ? `${API_BASE_URL}${item.coverUrl}` : null;
}
